// extracted by mini-css-extract-plugin
export default {"card":"CategoryInfoCard_card__8Y6tv"};